// extracted by mini-css-extract-plugin
export default {"container":"Loading-module__container--wAyW_","myMts":"Loading-module__myMts--uan_z","spinner":"Loading-module__spinner--_A7yL"};